import { motion } from 'motion/react';
import { Container, Kicker, Mark } from './primitives';

const PRINCIPLES = ['Interpreta', 'Elimina', 'Efficienta'];

const EXAMPLES = [
  {
    code: '01',
    module: 'Operations',
    title: 'DDT letto dall\'AI',
    copy: 'Legge il documento del fornitore, estrae data, numero, fornitore e P.IVA, segnala i campi a bassa affidabilità, abbina le righe all\'ordine (ODA) e permette di contestare il documento.',
  },
  {
    code: '02',
    module: 'People',
    title: 'Controllo manodopera',
    copy: 'Riconcilia le ore inserite con quelle reali ricostruite dagli orari. Segnala ore gonfiate, giornate oltre le 12 ore, commesse sovrapposte, righe doppie, orari non dichiarati — per persona e per commessa, prima che l\'errore diventi un costo.',
  },
];

export function AIEngine({ index = '03' }: { index?: string }) {
  return (
    <section className="relative border-t border-border py-28 md:py-36">
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <Kicker index={index} label="Il motore AI" />
          <h2 className="boss-display mt-5 text-balance text-[40px] md:text-[64px]">
            L'AI legge il dato grezzo. <Mark>E lo concilia da sola.</Mark>
          </h2>
          <p className="mt-5 max-w-xl text-pretty text-[16px] leading-[1.55] text-fg-2">
            Non uno slogan: due esempi reali, già in beta. Due lavori noiosi e pieni di errori — leggere i
            documenti dei fornitori, riconciliare le ore — fatti in automatico.
          </p>

          <div className="mt-7 flex flex-wrap items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
            {PRINCIPLES.map((p, i) => (
              <span key={p} className="flex items-center gap-2">
                <span className="text-primary">{p}</span>
                {i < PRINCIPLES.length - 1 && <span className="text-fg-disabled">·</span>}
              </span>
            ))}
          </div>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2">
          {EXAMPLES.map((e, i) => (
            <motion.div
              key={e.code}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="rounded-2xl border border-border bg-card p-7"
            >
              <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-fg-disabled">
                <span className="text-primary">{e.code}</span>
                <span className="h-px w-4 bg-border" />
                <span>{e.module}</span>
              </div>
              <h3 className="mt-4 text-[24px] font-light leading-[1.15] tracking-tight">{e.title}</h3>
              <p className="mt-3 text-pretty text-[14px] leading-[1.6] text-fg-2">{e.copy}</p>
            </motion.div>
          ))}
        </div>
      </Container>
    </section>
  );
}
